module.exports = __webpack_public_path__ + "img/605_2.b0062532.jpg";